import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type CurrentStore = {
	uuid: string
	slug: string
	name: string
	logo_url?: string | null
	tagline?: string | null
	city?: string | null
	zip?: string | null
	address?: string | null
	phone?: string | null
	email?: string | null
	instagram?: string | null
	working_hours?: Record<string, unknown> | null
	paypal_client_id?: string | null
	paypal_mode?: string | null
	invoice_counter?: number | null
}

const initialState: { current: CurrentStore | null } = {
	current: null,
}

const storeSlice = createSlice({
	name: 'store',
	initialState,
	reducers: {
		setCurrentStore(_state, action: PayloadAction<CurrentStore | null>) {
			return { current: action.payload }
		},
		setStoreInvoiceCounter(state, action: PayloadAction<number>) {
			if (!state.current) return state
			return {
				current: { ...state.current, invoice_counter: action.payload },
			}
		},
		clearCurrentStore() {
			return initialState
		},
	},
})

export const { setCurrentStore, setStoreInvoiceCounter, clearCurrentStore } = storeSlice.actions
export default storeSlice.reducer
